import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { AccessCalendarSyncFragment } from 'generated/resources/graphql'
import { capitalize } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import { ConfirmRevokeAccessModal, useRevokeAccess } from 'modules/cronofy/components/RevokeAccess'

interface Props {
  calendarSync: AccessCalendarSyncFragment
}

export const ConnectedCalendar = ({ calendarSync }: Props) => {
  const { mustConfirm, openConfirmModal, closeConfirmModal, revokeAccess, processing } =
    useRevokeAccess()

  return (
    <Box height="full" gap="s24" justifyContent="center">
      <Box gap="s12">
        <Text.Normal size="300" weight="semibold">
          {i18n.t('cronofy.user_calendar_sync.connected_calendar.title')}
        </Text.Normal>
        <Text.Normal size="300">
          {i18n.t('cronofy.user_calendar_sync.connected_calendar.description')}
        </Text.Normal>
      </Box>
      {calendarSync.provider && (
        <Text.Normal size="300">
          {i18n.tView('cronofy.user_calendar_sync.connected', {
            provider: <Text.Normal weight="bold">{capitalize(calendarSync.provider)}</Text.Normal>,

            profileName: <Text.Normal weight="bold">{calendarSync.profileName}</Text.Normal>,
          })}
        </Text.Normal>
      )}
      <>
        <Button onClick={() => openConfirmModal(calendarSync.id)} iconName="deny">
          {i18n.t('cronofy.user_calendar_sync.disconnect_calendar')}
        </Button>
        <ConfirmRevokeAccessModal
          open={mustConfirm}
          disabled={processing}
          sameUser
          onClose={closeConfirmModal}
          onSubmit={revokeAccess}
        />
      </>
    </Box>
  )
}
